export function enumToKeyName<TEnumKey extends string, TEnumVal extends string | number>(
  enumKey: { [key in TEnumKey]: TEnumVal },
  enumValue: TEnumVal
): string | undefined {
  const keys = (Object.keys(enumKey) as TEnumKey[]).filter((x) => enumKey[x] === enumValue);
  return keys.length > 0 ? keys[0] : undefined;
}
